import React, { useState, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux";
import { onSetBorderVisibility, onsetClrPicContext, onsetDropShadowVisibility, onSetFontStylesVisibility, onSetTextEditorVisibility, onSetErrorFontStylesVisibility } from "../../../../../../stateManager/store/common/action";
import { Wrapper } from "../Panel";
import { TextArea } from "../TextArea";
const TextEditorPopper = ((props: any) => {
    const { field, isCheckedIn, handleChange, where }: any = props;
    const { key, label, placeholder, section } = field;
    // const [visiblePopper,setVisiblePopper] = useState(false)
    const [value, setValue] = useState<any>(null)

    const { textEditorVisibility, colorPickerContext } = useSelector((state: any) => state.common);
    
    const dispatch = useDispatch()
    const ref = useRef(null)

    useEffect(() => {
        if (value) {
            handleChange(where, value.desc)
        }
    }, [value])

    const setVisibility = (visible: boolean) => {
        dispatch(onSetTextEditorVisibility(visible))
    }


    const handleClickOutside = (event: any) => {
        let curr: any = ref && ref?.current;
        if (curr && !curr.contains(event.target) && textEditorVisibility) {
            setVisibility(false)
        }
    };

    useEffect(() => {
        setVisibility(false)
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);


    return (
        <>
            <Wrapper key={key}>
                <p className="panel-label">
                    {label}
                </p>
                <p
                    className="col-span-1 font-medium rounded-md cursor-pointer "
                    style={{
                        color: "#0466C8",
                        backgroundColor: "rgba(4, 102, 200, 0.1)",
                        height: "28px",
                        width: "170px",
                        padding: "5px"
                    }}
                    onClick={((e) => {
                        e.stopPropagation();
                        setVisibility(!textEditorVisibility)
                        dispatch(onsetDropShadowVisibility(false))
                        dispatch(onSetBorderVisibility(false))
                        dispatch(onSetFontStylesVisibility(false))
                        dispatch(onSetErrorFontStylesVisibility(false))
                        dispatch(onsetClrPicContext({
                            ...colorPickerContext,
                            visibility: false,
                          }))
                    })}
                >
                    <div className="flex items-center justify-center">
                        <p>{placeholder}</p>
                    </div>
                </p>
            </Wrapper>
            {textEditorVisibility &&
                <div ref={ref}  onClick={(e)=>e.stopPropagation()}>
                    <TextArea
                        label={field.label}
                        idx={null}
                        visibility={textEditorVisibility}
                        setVisibility={setVisibility}
                        setValue={setValue}
                        value={{ val: props.value }}
                    />
                </div>
            }
        </>
    )
})
export default TextEditorPopper;